import { useContext, useEffect, useRef, useState } from "react";
import { getAllTransaction, getGeneralData } from "../../../../Utility/Api";
import "bootstrap/dist/css/bootstrap.min.css";
import { currentMonth, NaviGate, shop_id } from "../../../../Utility/function";
import { Paginations } from "../../../Common/Functions";
import { WarehouseContext } from "../../../../Utility/UserContext";

const AllTransaction = () => {
    const contentRef = useRef(null);
    const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
    const [filterType, setFilterType] = useState("daily");
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
    const [selectedWeek, setSelectedWeek] = useState(getCurrentWeek());
    const [selectedMonth, setSelectedMonth] = useState(currentMonth());
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
    const [customFromDate, setCustomFromDate] = useState("");
    const [customToDate, setCustomToDate] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [allTransactions, setAllTransactions] = useState([]);
    const [companyInfo, setCompanyInfo] = useState({
        name: "Company Name",
        address: "123 Business Street, City, State 12345",
        phone: "(123) 456-7890",
        email: "info@yourcompany.com"
    });

    useEffect(() => {
        if (shopItem) {
            setCompanyInfo({
                name: shopItem?.title || "",
                address: shopItem?.Address || "123 Business Street, City, State 12345",
                phone: shopItem?.phone1 || "",
                email: shopItem?.email || ""
            })
        }

    }, [shopItem])

    // Helper function to get current week range
    function getCurrentWeek() {
        const today = new Date();
        const firstDay = new Date(today.setDate(today.getDate() - today.getDay()));
        const lastDay = new Date(today.setDate(today.getDate() - today.getDay() + 6));

        return {
            start: firstDay.toISOString().split('T')[0],
            end: lastDay.toISOString().split('T')[0]
        };
    }

    // Helper function to get week range from date
    function getWeekRange(dateString) {
        const date = new Date(dateString);
        const firstDay = new Date(date.setDate(date.getDate() - date.getDay()));
        const lastDay = new Date(date.setDate(date.getDate() - date.getDay() + 6));

        return {
            start: firstDay.toISOString().split('T')[0],
            end: lastDay.toISOString().split('T')[0]
        };
    }

    useEffect(() => {
        updateDateRange();
    }, [filterType, selectedDate, selectedWeek, selectedMonth, selectedYear, customFromDate, customToDate]);

    useEffect(() => {
        if (fromDate && toDate) {
            fetchTransactionData();
        }
    }, [fromDate, toDate]);

    const updateDateRange = () => {
        let startDate = "";
        let endDate = "";

        switch (filterType) {
            case "daily":
                startDate = selectedDate;
                endDate = selectedDate;
                break;
            case "weekly":
                startDate = selectedWeek.start;
                endDate = selectedWeek.end;
                break;
            case "monthly":
                startDate = `${selectedMonth}-01`;
                const lastDay = new Date(
                    new Date(startDate).getFullYear(),
                    new Date(startDate).getMonth() + 1,
                    0
                ).getDate();
                endDate = `${selectedMonth}-${lastDay}`;
                break;
            case "yearly":
                startDate = `${selectedYear}-01-01`;
                endDate = `${selectedYear}-12-31`;
                break;
            case "custom":
                startDate = customFromDate;
                endDate = customToDate;
                break;
            default:
                break;
        }

        setFromDate(startDate);
        setToDate(endDate);
    };

    const fetchTransactionData = async () => {
        try {
            var filter = `start_date=${fromDate}&end_date=${toDate}&shop_id=${shop_id}`;
            const res = await getAllTransaction(filter);
            if (res.data && res.data.data) {
                setAllTransactions(res.data.data);
            }
        } catch (err) {
            console.log("Transaction Error", err);
        }
    };

    const handleWeekChange = (dateString) => {
        setSelectedWeek(getWeekRange(dateString));
    };

    const handlePrint = () => {
        // Create a new window for printing
        const printWindow = window.open('', '_blank');

        // Get the printable content
        const printContent = document.getElementById('printable-report').innerHTML;

        // Write the content to the new window
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>All Transactions Report</title>
                <style>
                    @media print {
                        @page {
                            size: A4 portrait;
                            margin: 0.5in;
                        }
                        body {
                            font-family: Arial, sans-serif;
                            font-size: 12pt;
                            color: #000;
                            background: #fff;
                        }
                        .print-container {
                            width: 100%;
                            max-width: 21cm;
                            margin: 0 auto;
                        }
                        .print-header {
                            text-align: center;
                            margin-bottom: 20px;
                            border-bottom: 2px solid #000;
                            padding-bottom: 15px;
                        }
                        .print-header h1 {
                            font-size: 20pt;
                            margin: 0;
                            color: #000;
                        }
                        .print-header p {
                            margin: 5px 0;
                            font-size: 11pt;
                        }
                        .report-info {
                            margin: 15px 0;
                            padding: 10px;
                            background-color: #f8f9fa;
                            border-radius: 5px;
                        }
                        .report-table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 15px 0;
                            font-size: 10pt;
                        }
                        .report-table th, .report-table td {
                            border: 1px solid #ddd;
                            padding: 8px;
                            text-align: left;
                        }
                        .report-table th {
                            background-color: #f2f2f2;
                            font-weight: bold;
                        }
                        .report-totals {
                            margin-top: 20px;
                            padding: 15px;
                            border: 1px solid #ddd;
                            border-radius: 5px;
                            background-color: #f9f9f9;
                        }
                        .total-row {
                            display: flex;
                            justify-content: space-between;
                            margin: 5px 0;
                        }
                        .total-amount {
                            font-weight: bold;
                            font-size: 13pt;
                        }
                        .text-success {
                            color: #28a745 !important;
                        }
                        .text-danger {
                            color: #dc3545 !important;
                        }
                        .footer {
                            margin-top: 30px;
                            text-align: center;
                            font-size: 10pt;
                            color: #6c757d;
                        }
                    }
                </style>
            </head>
            <body>
                ${printContent}
                <script>
                    // Print automatically when the window loads
                    window.onload = function() {
                        window.print();
                        // Close the window after printing
                        setTimeout(function() {
                            window.close();
                        }, 100);
                    };
                </script>
            </body>
            </html>
        `);

        printWindow.document.close();
    };

    const renderFilterControls = () => {
        switch (filterType) {
            case "daily":
                return (
                    <div className="col-auto">
                        <div className="form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="selectedDate"
                                value={selectedDate}
                                onChange={(e) => setSelectedDate(e.target.value)}
                            />
                            <label htmlFor="selectedDate">Select Date</label>
                        </div>
                    </div>
                );
            case "weekly":
                return (
                    <div className="col-auto">
                        <div className="form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="weekDate"
                                value={selectedWeek.start}
                                onChange={(e) => handleWeekChange(e.target.value)}
                            />
                            <label htmlFor="weekDate">Select Week</label>
                        </div>
                    </div>
                );
            case "monthly":
                return (
                    <div className="col-auto">
                        <div className="form-floating">
                            <input
                                type="month"
                                className="form-control"
                                id="selectedMonth"
                                value={selectedMonth}
                                onChange={(e) => setSelectedMonth(e.target.value)}
                            />
                            <label htmlFor="selectedMonth">Select Month</label>
                        </div>
                    </div>
                );
            case "yearly":
                return (
                    <div className="col-auto">
                        <div className="form-floating">
                            <input
                                type="number"
                                className="form-control"
                                id="selectedYear"
                                min="2000"
                                max="2100"
                                value={selectedYear}
                                onChange={(e) => setSelectedYear(e.target.value)}
                            />
                            <label htmlFor="selectedYear">Select Year</label>
                        </div>
                    </div>
                );
            case "custom":
                return (
                    <>
                        <div className="col-auto">
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="customFromDate"
                                    value={customFromDate}
                                    onChange={(e) => setCustomFromDate(e.target.value)}
                                />
                                <label htmlFor="customFromDate">From Date</label>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="customToDate"
                                    value={customToDate}
                                    onChange={(e) => setCustomToDate(e.target.value)}
                                />
                                <label htmlFor="customToDate">To Date</label>
                            </div>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <div className="page-content py-1">
            <NaviGate />
            <div className="card  p-3  mx-2 overflow-y-scroll" style={{ minHeight: "90vh" }} ref={contentRef}>
                <div className="row mb-4 border-bottom justify-content-between align-items-center w-100 pb-3">
                    <h5 className="text-start w-auto fw-bold mb-0">
                        All Transactions
                    </h5>
                    <div className="w-auto d-flex gap-2 mt-0 justify-content-end align-items-center">
                        <div className="col-auto ps-0">
                            <div className="form-floating">
                                <select
                                    className="form-select"
                                    id="filterType"
                                    value={filterType}
                                    onChange={(e) => setFilterType(e.target.value)}
                                >
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="yearly">Yearly</option>
                                    <option value="custom">Custom Range</option>
                                </select>
                                <label htmlFor="filterType">Filter By</label>
                            </div>
                        </div>

                        {renderFilterControls()}

                        <button
                            type="button"
                            className="btn btn-dark ms-2"
                            onClick={handlePrint}
                        >
                            Print Report
                        </button>
                    </div>
                </div>

                <div className="d-flex justify-content-between mb-3">
                    <div>
                        <strong>Date Range:</strong> {fromDate} to {toDate}
                    </div>
                </div>

                <div className="row g-4 pt-0">
                    <div className="col-md-12 mt-2">
                        <TransactionTable
                            transactions={allTransactions}
                            dateRange={`${fromDate} to ${toDate}`}
                        />
                    </div>
                </div>

                {/* Printable Report (Hidden from normal view) */}
                <div id="printable-report" style={{ display: 'none' }}>
                    <div className="print-container">
                        <div className="print-header">
                            <h1>{companyInfo.name}</h1>
                            <p>{companyInfo.address}</p>
                            <p>Phone: {companyInfo.phone} | Email: {companyInfo.email}</p>
                            <h2>All Transactions Report</h2>
                        </div>

                        <div className="report-info">
                            <p><strong>Report Period:</strong> {fromDate} to {toDate}</p>
                            <p><strong>Generated On:</strong> {new Date().toLocaleDateString()}</p>
                        </div>

                        <PrintableTransactionTable transactions={allTransactions} />

                        <div className="footer">
                            <p>Report generated on {new Date().toLocaleDateString()} at {new Date().toLocaleTimeString()}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TransactionTable = ({ transactions }) => {
    const [transactionData, setTransactionData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;

    const totalPages = Math.ceil(transactionData.length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const paginatedData = transactionData.slice(startIndex, startIndex + rowsPerPage);

    useEffect(() => {
        const updatedTransactionData = transactions
            .filter((item) => item.status !== "-1" && item.status !== "2")
            .map((item) => {
                if (item.amount) {
                    return {
                        date: item.date,
                        ref_id: item.ref_id,
                        remarks: item.remarks,
                        debit: item.is_debit == "1" ? item.amount : "0.0000",
                        credit: item.is_debit == "0" ? item.amount : "0.0000",
                    }
                }
                return null;
            })
            .filter(item => item !== null);

        setTransactionData(updatedTransactionData);
    }, [transactions]);

    // Calculate totals
    const totalDebit = transactionData.reduce((sum, item) => sum + parseFloat(item.debit || 0), 0);
    const totalCredit = transactionData.reduce((sum, item) => sum + parseFloat(item.credit || 0), 0);

    return (
        <>
            <div className="bg-gray-100 min-h-screen">
                <div className="w-full bg-white shadow-md rounded-lg overflow-hidden">
                    <h4 className="text-xl font-bold text-center bg-dark text-white py-2 mb-0">All Transactions</h4>

                    <table className="w-full table border-collapse text-sm table-hover table-bordered mb-0">
                        <thead>
                            <tr className="bg-green text-white">
                                <th className="py-2 px-4 text-left">Date</th>
                                <th className="py-2 px-4 text-right">Reference ID</th>
                                <th className="py-2 px-4 text-right">Remarks</th>
                                <th className="py-2 px-4 text-right">Debit</th>
                                <th className="py-2 px-4 text-right">Credit</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData.map((item, index) => (
                                <tr key={index} className={`border-b ${index % 2 === 0 ? "bg-gray-50" : "bg-white"}`}>
                                    <td className="py-2 px-4">{item?.date}</td>
                                    <td className="py-2 px-4">{item?.ref_id}</td>
                                    <td className="py-2 px-4">{item?.remarks}</td>
                                    <td className="py-2 px-4 text-end text-green-600 font-medium">{parseFloat(item?.debit || 0).toFixed(3)}</td>
                                    <td className="py-2 px-4 text-end text-green-600 font-medium">{parseFloat(item?.credit || 0).toFixed(3)}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="bg-light">
                                <td colSpan="3" className="py-2 px-4 text-end fw-bold">Page Totals:</td>
                                <td className="py-2 px-4 text-end fw-bold">
                                    {paginatedData.reduce((sum, item) => sum + parseFloat(item.debit || 0), 0).toFixed(3)}
                                </td>
                                <td className="py-2 px-4 text-end fw-bold">
                                    {paginatedData.reduce((sum, item) => sum + parseFloat(item.credit || 0), 0).toFixed(3)}
                                </td>
                            </tr>
                            <tr className="bg-light">
                                <td colSpan="3" className="py-2 px-4 text-end fw-bold">Grand Totals:</td>
                                <td className="py-2 px-4 text-end fw-bold">{totalDebit.toFixed(3)}</td>
                                <td className="py-2 px-4 text-end fw-bold">{totalCredit.toFixed(3)}</td>
                            </tr>
                        </tfoot>
                    </table>

                    <Paginations
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                    />
                </div>
            </div>
        </>
    );
};

const PrintableTransactionTable = ({ transactions }) => {
    const [transactionData, setTransactionData] = useState([]);

    useEffect(() => {
        const updatedTransactionData = transactions
            .filter((item) => item.status !== "-1" && item.status !== "2")
            .map((item) => {
                if (item.amount) {
                    return {
                        date: item.date,
                        ref_id: item.ref_id,
                        remarks: item.remarks,
                        debit: item.is_debit == "1" ? item.amount : "0.0000",
                        credit: item.is_debit == "0" ? item.amount : "0.0000",
                    }
                }
                return null;
            })
            .filter(item => item !== null);

        setTransactionData(updatedTransactionData);
    }, [transactions]);

    // Calculate totals
    const totalDebit = transactionData.reduce((sum, item) => sum + parseFloat(item.debit || 0), 0);
    const totalCredit = transactionData.reduce((sum, item) => sum + parseFloat(item.credit || 0), 0);

    return (
        <>
            <table className="report-table">
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Date</th>
                        <th>Reference ID</th>
                        <th>Remarks</th>
                        <th>Debit Amount</th>
                        <th>Credit Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {transactionData.length > 0 ? (
                        transactionData.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.date}</td>
                                <td>{item.ref_id}</td>
                                <td>{item.remarks}</td>
                                <td className="text-success">{parseFloat(item.debit || 0).toFixed(3)}</td>
                                <td className="text-success">{parseFloat(item.credit || 0).toFixed(3)}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'center' }}>
                                No transactions available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {transactionData.length > 0 && (
                <div className="report-totals">
                    <h3>Summary</h3>
                    <div className="total-row">
                        <span>Total Debit Amount:</span>
                        <span className="total-amount">{totalDebit.toFixed(3)}</span>
                    </div>
                    <div className="total-row">
                        <span>Total Credit Amount:</span>
                        <span className="total-amount">{totalCredit.toFixed(3)}</span>
                    </div>
                    <div className="total-row" style={{ borderTop: '1px solid #ddd', paddingTop: '10px', marginTop: '10px' }}>
                        <span>Net Amount:</span>
                        <span className="total-amount">{(totalDebit - totalCredit).toFixed(3)}</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default AllTransaction;